module.exports = __webpack_public_path__ + "static/media/Tell_Your_Guests_QR_Code.ee21960f.png";